import React, { useState, useEffect } from 'react';
import { 
  FileText, 
  CheckCircle, 
  Clock, 
  XCircle, 
  AlertCircle,
  Building,
  Upload,
  File,
  X,
   Trash, 
   Loader,
   CreditCard
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../axios'; // Axios instance
import { ToastContainer, toast } from 'react-toastify';
import ProjectUploadWizard  from '../components/ProjectUploadWizard';
import ProjectDataTable from './ProjectDataTable';

// Main CustomerDashboard Component
const CustomerDashboard = () => {
  const [projectStats, setProjectStats] = useState({
    total: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
  });
  const [recentProjects, setRecentProjects] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
  // Get user from localStorage
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {

      if (!user) {
        window.location.href = "/login";
        return;
      }
      
      if(user?.role_id != 0){
        window.location.href = "/home"; // Redirect if not logged in
        return;
      }
      
  }, []);

  // Function to get status color class
  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "bg-green-100 text-green-800";
      case "pending":
        return "bg-yellow-100 text-yellow-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="pt-16">
      {/* Welcome Section */}
      <div className="mb-8 py-24 bglog flex flex-col align-middle justify-center items-center">
        <h1 className="text-2xl font-bold text-white mb-2">Welcome, {user?.name}</h1>
        <p className="text-gray-300">Manage your building approval projects and track their status</p>
      </div>

      <div className="p-6">
        {/* Stats Grid */}
         {/* Quick Actions */}
         <div className="bg-white rounded-lg shadow mb-8">
          <div className="px-6 py-4 border-b border-gray-200">
            <h2 className="text-lg font-medium text-gray-900">Quick Actions</h2>
          </div>
          <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            
            <button
              onClick={() =>{
                navigate('/new-project');
              } 

              }
              className="flex items-center justify-center space-x-2 p-4 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
            >
              <Upload className="h-6 w-6 text-blue-600" />
              <span className="text-blue-600 font-medium">New Project</span>
            </button>
            <button
            
              onClick={() =>{
                navigate('/transaction-history');
              } 

              }
            className="flex items-center justify-center space-x-2 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
              <CreditCard className="h-6 w-6 text-gray-600" />
              <span className="text-gray-600 font-medium">Transactions History</span>
            </button>
            
            <button 
                 onClick={() =>{
                  navigate('/settings');
                } 
  
                }
            
            className="flex items-center justify-center space-x-2 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
              <Building className="h-6 w-6 text-gray-600" />
              <span className="text-gray-600 font-medium">Settings</span>
            </button>


          </div>
        </div>

        {/* Recent Projects Table */}
        <ProjectDataTable user={user} />
   
      </div>

      {/* New Project Modal */}
      <ProjectUploadWizard isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
         <ToastContainer 
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
    </div>
  );
};


export default CustomerDashboard;